import Header from 'components/constants/header';

export default function Layout({ children }) {
  return (
    <>
      <Header />
      <div className="p-3 dark:bg-gray-800">{children}</div>
    </>
  );
}
